import React from 'react';

const TreeViewItemText = ({ title, description = '' }) => (
  <div className="ws-ui-tree-view-item-text">
    <span className="ws-ui-tree-view-item-text__title">{title}</span>
    {description && <span className="ws-ui-tree-view-item-text__description">{description}</span>}
  </div>
);

export default TreeViewItemText;
